import classNames from 'classnames';
import { addDays, format } from 'date-fns';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Text } from 'ui';
import { areTomorrowTodosEnabled } from 'common/validators';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EventFeedback, type EventFeedbackOptions } from 'features/events/event-feedback';
import { useTodosWidget } from './context';
import { TodosWidgetContent } from './todos-widget-content';
import { TodosWidgetHeader } from './todos-widget-header';

type P = {
  className?: string;
  feedbackOptions: EventFeedbackOptions;
  hideTodosFeedCta?: boolean;
};

const TodosWidget = ({ className, feedbackOptions, hideTodosFeedCta }: P) => {
  const { t } = useTranslation();
  const { activeKey, setActiveKey } = useTodosWidget();
  const [numberOfTodosTotal, setNumberOfTodosTotal] = useState<number>();
  const tomorrowDate = format(addDays(new Date(), 1), 'yyyy-MM-dd');

  return (
    <Card
      className={classNames('todos-widget', className)}
      extra={
        areTomorrowTodosEnabled() ? undefined : (
          <Text type="secondary">{t('dateFormats.shortMonthDayYear', { date: new Date() })}</Text>
        )
      }
      marginBottom={false}
      title={
        areTomorrowTodosEnabled() ? (
          <TodosWidgetHeader activeKey={activeKey} setActiveKey={setActiveKey} />
        ) : (
          <Text size="small" type="secondary">
            {t(`To-Dos for today`, {
              numberOfTodos: numberOfTodosTotal ?? '?',
            })}
          </Text>
        )
      }
    >
      <>
        <EventFeedback {...feedbackOptions} />

        {activeKey === 'today' ? (
          <TodosWidgetContent hideTodosFeedCta={hideTodosFeedCta} setNumberOfTodosTotal={setNumberOfTodosTotal} />
        ) : (
          <TodosWidgetContent date={tomorrowDate} hideTodosFeedCta={hideTodosFeedCta} />
        )}
      </>
    </Card>
  );
};

export default TodosWidget;
